<template>
  <login-template
    class="login-page"
    :account-slug="accountSlug"
    :warn-explorer="$attrs['warn-explorer']"
    :config-logo="configLogo"
  >
    <!-- modais -->
    <template slot-scope="{ companyProps, configProps }">
      <login-modal
        v-if="error.type === 'userNotFound' || error.type === 'notEnabled' && !errorCompanies.length"
        :opened="error.type === 'userNotFound' || error.type === 'notEnabled' && !errorCompanies.length"
        title="Ops..."
        main-text="Há um erro no seu cadastro!"
        end-text="para que possamos te ajudar a acessar a sua conta."
        redirect-text
        type="disappointed"
        @close="$emit('clear-error')"
        @open-support-modal="supportIsOpened = true"
      />

      <login-modal
        v-if="error.type === 'notActive'"
        :opened="error.type === 'notActive'"
        title="Ops..."
        main-text="Você ainda não se cadastrou"
        text="Para ativar a sua conta clique no botão ATIVAR CONTA e insira o seu CPF."
        type="disappointed"
        button="Entendi"
        @close="$emit('clear-error')"
      />

      <login-modal
        v-if="error.type === 'inactiveCompany'"
        :opened="error.type === 'inactiveCompany'"
        main-text="Ops! Clube desativado!"
        begin-text="Desculpe, mas este clube esta temporariamente inativo. Até que ele seja reativado, você não conseguirá acessá-lo."
        end-text="para saber mais."
        redirect-text
        type="sad"
        @close="$emit('clear-error')"
        @open-support-modal="supportIsOpened = true"
      />

      <login-modal
        v-if="error.type === 'inactiveAccount'"
        :opened="error.type === 'inactiveAccount'"
        main-text="Ops! Acesso negado!"
        begin-text="Desculpe, mas sua conta esta temporariamente inativa."
        end-text="para que possamos te ajudar a acessar a sua conta."
        redirect-text
        type="sad"
        @close="$emit('clear-error')"
        @open-support-modal="supportIsOpened = true"
      />

      <login-modal
        v-if="error.type === 'notEnabled' && !!errorCompanies.length"
        :opened="error.type === 'notEnabled' && !!errorCompanies.length"
        class="modal"
        title="Ops..."
        main-text="Você não está cadastrado neste portal."
        type="sad"
        @close="$emit('clear-error')"
      >
        <div class="modal-carrousel">
          <p class="text">
            <strong>Mas você pode acessar outro(s) clube(s).</strong><br />
            Clique no clube que deseja ser redirecionado.
          </p>

          <swiper
            :class="['carousel', { '-center': errorCompanies.length === 2 }]"
            :options="swiperOptions"
          >
            <swiper-slide
              v-for="(company, index) in error.data.companies"
              :key="index"
            >
              <a
                class="card-link"
                :href="company.url"
                target="_blank"
              >
                <c-card class="item">
                  <c-image
                    is-background
                    class="logo"
                    :src="company.logo"
                    :placeholder="require('@/assets/img/campaign-placeholder.svg')"
                    width="85px"
                    height="70px"
                  />
                </c-card>
              </a>
              <p class="text">
                {{ company.name }}
              </p>
            </swiper-slide>

            <div
              class="swiper-button -prev"
              slot="button-prev"
            >
              <k-icon
                class="icon"
                icon="left1"
                size="22"
              />
            </div>
            <div
              class="swiper-button -next"
              slot="button-next"
            >
              <k-icon
                class="icon"
                icon="arrow-right"
                size="22"
              />
            </div>
          </swiper>
        </div>
      </login-modal>

      <!-- Modal de seleção de clube -->
      <select-company-modal
        v-if="hasCompanies && openSelection"
        :open-selection="hasCompanies && openSelection"
        :companies="companiesSelection"
        @close-selection="openSelection = false"
        @company-selected="companySelected($event)"
      />

      <!-- support modal -->
      <support-modal-container
        v-else-if="supportIsOpened"
        :is-opened="supportIsOpened"
        v-if="supportIsOpened"
        @close="supportIsOpened = false"
      />

      <form
        class="form"
        @submit.prevent="$emit('submit', userData)"
      >
        <!-- TODO: Change placeholder: -->
        <c-image
          :class="['logo-form', {'-itau' : accountSlug === 'pic-itau-r4g'}]"
          :src="configLogo"
          data-cy="company-logo"
          is-background
          wait-load
          placeholder="~@/assets/img/campaign-placeholder.svg"
        />

        <p
          :class="['text', {'-itau' : accountSlug === 'pic-itau-r4g'}]"
          data-cy="login-company-description"
        >
          {{ configProps.intro || defaultText }}
        </p>
        <c-input
          required
          icon="contacts"
          :has-error="isDocumentInvalid"
          placeholder="Insira seu CPF"
          class="input-data"
          name="CPF"
          input-mode="numeric"
          :mask="'###.###.###-##'"
          :disabled="isLoading"
          validation-icon="warning-circle"
          :validation="isDocumentInvalid ? documentError : ''"
          v-model="userData.document"
          data-cy="login-document-input"
        />
        <c-input
          required
          :has-error="isPasswordInvalid"
          icon="lock2"
          placeholder="Insira sua senha"
          type="password"
          class="input-data"
          name="Senha"
          validation-icon="warning-circle"
          :validation="isPasswordInvalid ? passwordError : ''"
          :disabled="isLoading"
          v-model="userData.password"
          data-cy="login-password-input"
          :has-html-protection="false"
        />

        <div class="under-input">
          <a
            @click.prevent="$router.push({ name: 'Esqueci minha senha' })"
            class="forget-pwd"
            data-cy="login-forget-password-link"
          >
            Esqueci a senha
          </a>
        </div>

        <div class="btn-group">
          <c-button
            primary
            size="lg"
            :disabled="isLoading || isFormInvalid"
            @click="validate"
            :class="['btn', 'btn-main', {'-itau' : accountSlug === 'pic-itau-r4g'}]"
            data-cy="login-button"
            :loading="isLoading"
          >
            Entrar
          </c-button>

          <span
            v-if="!config.generic_app"
            class="lines"
          >OU</span>

          <c-button
            v-if="!config.generic_app"
            data-cy="login-account-activate-button"
            default
            size="lg"
            type="button"
            :class="['btn', 'btn-secondary', {'-radius' : accountSlug === 'pic-itau-r4g'}]"
            :disabled="isLoading"
            @click="$router.push('ativar-conta')"
          >
            Ativar Conta
          </c-button>
        </div>

        <span class="support">Não consegue acessar sua conta?
          <a
            class="action"
            data-cy="login-support-link"
            @click="supportIsOpened = true"
          >Clique aqui</a>
        </span>
      </form>
    </template>
  </login-template>
</template>

<script>
import LoginTemplate from '@/components/Login/LoginTemplate'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { CONFIG_MAIN, AUTH_LOGIN_GENERIC_APP, FEEDBACK } from '@store/types'
import { mapGetters, mapActions } from 'vuex'
import isValidCPF from '@helpers/validate/isValidCPF'
import { KIcon } from 'kaledo-components'

const SWIPER_DEFAULTS = {
  freeMode: true,
  spaceBetween: 20,
  slidesPerView: 2.5,
  slidesPerGroup: 2.5,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button.-next',
    prevEl: '.swiper-button.-prev',
    disabledClass: '-disabled',
    hiddenClass: '-hidden'
  },
  breakpoints: {
    640: { slidesPerView: 1 },
    840: { slidesPerView: 2 }
  }
}

export default {
  components: {
    SupportModalContainer: () => import('@/containers/Login/SupportModalContainer'),
    SelectCompanyModal: () => import('@components/Login/SelectCompanyModal'),
    LoginModal: () => import('@/components/Login/LoginModal'),
    LoginTemplate,
    swiperSlide,
    swiper,
    KIcon
  },

  props: {
    accountSlug: {
      type: String,
      required: true
    },
    error: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    configLogo: String,
    companiesSelection: Object
  },

  data () {
    return {
      touched: false,
      supportIsOpened: false,
      defaultText: 'Economize na compra de produtos e serviços das marcas que você mais curte.',
      userData: { document: '', password: '' },
      placeholder: () => require('@/assets/img/campaign-placeholder.svg'),
      openSelection: false
    }
  },

  computed: {
    ...mapGetters({
      config: CONFIG_MAIN
    }),

    documentError () {
      return !(this.userData.document || []).length
        ? 'Campo obrigatório'
        : !isValidCPF(this.userData.document) ? 'CPF inválido' : ''
    },

    passwordError () {
      return !(this.userData.password || []).length ? 'Campo obrigatório' : 'Senha inválida.'
    },

    hasDocumentAndPassword () {
      return (this.userData.document || []).length && (this.userData.password || []).length
    },

    isDirty () {
      if (this.touched) return true
      this.touched = Object.values(this.userData).some(value => value)
      return this.touched
    },

    isDocumentInvalid () {
      const isFieldInvalid = (this.isDirty && this.userData.document.length !== 14) || !isValidCPF(this.userData.document)

      return isFieldInvalid || this.error.type === 'invalidCredentials'
    },

    isPasswordInvalid () {
      const isFieldInvalid = this.isDirty && !this.userData.password.length
      const hasError = (this.error.type === 'invalidPassword' || this.error.type === 'invalidCredentials')

      return isFieldInvalid || hasError
    },

    isFormInvalid () {
      return this.isDocumentInvalid || this.isPasswordInvalid || !this.hasDocumentAndPassword
    },

    errorCompanies () {
      return (this.error.data && this.error.data.companies) || []
    },

    companyName () {
      return this.error.data && this.error.data.company_name
        ? `[${this.error.data.company_name}]`
        : ''
    },

    swiperOptions () {
      const centeredSlides = this.errorCompanies.length < 2
      return { ...SWIPER_DEFAULTS, centeredSlides }
    },

    hasCompanies () {
      return Object.keys(this.companiesSelection).length > 1
    }
  },

  watch: {
    userData: {
      handler: function (value) {
        const type = this.error.type || ''
        if (type === 'invalidCredentials' || type === 'invalidPassword') { this.$emit('clear-error') }
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({
      genericLogin: AUTH_LOGIN_GENERIC_APP,
      createFeedback: FEEDBACK
    }),

    validate (ev) {
      this.openSelection = true

      if (this.touched) return true

      ev.preventDefault()
      this.touched = true
    },

    async companySelected (url) {
      const payload = {
        document: this.userData.document,
        password: this.userData.password,
        company: url
      }

      localStorage.setItem('url', url)

      const { token } = await this.genericLogin(payload)

      if (token) {
        window.dataLayer.push({
          event: 'login-app-geral'
        })
      } else {
        this.openSelection = false

        this.createFeedback({
          text: 'Credenciais inválidas',
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.login-page {
  position: relative;

  .form {
    display: flex;
    flex-direction: column;
    min-width: 250px;
    max-width: 320px;

    & >.logo-form {
      height: 100px;
      width: 190px;
      padding: 50px 95px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      margin-bottom: 40px;
      margin-top: 50px;
      align-self: center;

      &.-itau {
        width: 160px;
        padding: 50px 80px;
        margin-top: 20px !important;
      }
    }

    & >.text {
      margin-bottom: 25px;
      font-family: "Nunito Sans";
      color: $text-color;
      color: var(--signIn-mainText);
      font-size: 14px;
      line-height: 19px;

      &.-itau { font-size: 16px; font-family: "itauFont";}
    }
    & > .input-data {
      //margin-bottom: 35px !important;

      input:not(.-has-validation) {
        &:hover,
        &:active,
        &:focus {
          border-color: $primary-color-placeholder;
          box-shadow: 0 0 0 1px $primary-color-placeholder;
          outline: $primary-color-placeholder;

          // sobreescreve caso existam as variaveis:
          border-color: var(--color-secondary);
          box-shadow: 0 0 0 1px var(--color-secondary);
          outline: var(--color-secondary);
        }
      }
    }

    & > .under-input {
        margin-top: -10px;
        display: flex;
        position: relative;
        justify-content: space-between;

    & > .wrongdata {
        font-size: 12px;
        color: $failure-color;
        font-family: $base-font-family;
        font-weight: 100;
        padding-right: 100px;
        position: absolute;

        & > .icon {
          fill: $failure-color;
        }
      }
      & > .forget-pwd {
        position: absolute;
        font-size: 12px;
        right: 0;
        color: $forgotPassword-placeholder;
        color: var(--signIn-forgotPassword);
        font-family: $base-font-family;
        font-weight: 100;
        text-decoration: none;
        cursor: pointer;
      }
    }
    & > .btn-group {
      margin-top: 40px;
      margin-bottom: 40px;

      @include desktop {
        min-width: 320px;
      }

      & > .btn {
        width: 100%;
        margin: 10px 0px;
        font-family: $base-font-family;
        font-weight: 100;

        &.-disabled {
          opacity: 0.7;
        }

        @include itau;
      }

      @include radius;

      & > .lines{
        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 12px;
        width: 100%;
        text-align: center;
        margin: 15px auto;
        overflow: hidden;
        color: $signIn-or-placeholder;
        color: var(--signIn-or);
        font-family: $base-font-family;
        font-weight: 100;

        &:before {
          margin-left: -100%;
        }
        &:after {
          margin-right: -100%;
        }
        &:before,
        &:after {
          display: inline-block;
          content: '';
          background-color: $signIn-divisors-placeholder;
          background-color: var(--signIn-divisors);
          height: 1px;
          width: 100%;
          vertical-align: middle;
          box-sizing: border-box;
          border: solid $signIn-background-placeholder;
          border: solid var(--signIn-background);
          border-width: 0 10px;
        }
      }
    }
    & > .support {
      font-family: $base-font-family;
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 40px;
      color: $text-color;
      color: var(--signIn-mainText);
      text-align: center;

      & > .action {
        align-self: center;
        text-decoration: underline;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }

  .modal-carrousel {
    background-color: rgba(234,237,239, 0.25);
    margin: 20px -20px -15px -20px;
    padding: 45px 20px;

    & >.text {
      text-align: center;
      margin: 0 15%;
            // TODO: Perhaps change this color
      color: rgba(18,30,72,0.8);
    }
      & > .carousel {
        margin: 0 auto;
        margin-top: 10px;

        @include mobile {
          margin-top: 20px;
        }

        &.-center > .swiper-wrapper {
          transform: translate3d(49px, 0px, 0px) !important;
        }

        .swiper-slide {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 130px;
          min-width: 150px;

          & > .card-link > .item {
            width: 150px;
            height: 75px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 60px;
              height: 40px;
              padding: 20px 30px;
              background-position: center;
              background-size: contain;
              background-repeat: no-repeat;
            }
          }
          & >.text {
            margin-top: 5px;
            text-transform: uppercase;
            font-size: 11px;
            // TODO: Perhaps change this color
            color: rgba(18,30,72,0.8);
          }
        }

        & > .swiper-button {
          z-index: 20;
          background-color: rgba(234,237,239, 0.7);
          display: block;
          position: absolute;
          cursor: pointer;
          top: 50%;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          transition: opacity .3s ease;

          & > .icon {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }

          &.-disabled,
          &.-hidden { opacity: 0; }

          &.-prev {
            left: 0;
            transform: translate(-50%, -50%);

            & > .icon {
              right: 8px;
              position: absolute;
            }
          }

          &.-next {
            right: 0;
            transform: translate(50%, -50%);

            & > .icon {
              left: 8px;
              position: absolute;
            }
          }
        }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginPage.vue